<template lang="pug">
.zoom(id='zoom')
  .zoom__title ZOOM
  .zoom__subtitle Задайте вопрос спикеру в прямом эфире
  .zoom__content
    .zoom__item
      .zoom__img-block
        img.zoom__img(src='../static/zoom1.svg')
      .zoom__text Установите ZOOM <br> на устройство
    
    .zoom__item
      .zoom__img-block
        img.zoom__img(src='../static/zoom2.svg')
      .zoom__text Перейдите по ссылкe и дождитесь подключения от администратора конференции

    .zoom__item
      .zoom__img-block
        img.zoom__img(src='../static/zoom3.svg')
      .zoom__text Поставьте на mute звук в видео-плеере конференции

    .zoom__item
      .zoom__img-block
        img.zoom__img(src='../static/zoom4.svg')
      .zoom__text Задайте вопрос спикеру
</template>

<script>
export default {
  name: 'theHeader',
};
</script>

<style lang="sass">
.zoom
  padding: 97px 20px 207px
  max-width: 914px
  margin: 0 auto
  @media screen and (max-width: 812px)
    padding: 40px 20px 60px
    max-width: 375px
  &__title
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 2px;
    color: #FFFFFF;
    mix-blend-mode: normal;
    opacity: 0.3;
    margin-bottom: 95px
    font-weight: bold
    text-align: center
    @media screen and (max-width: 812px)
      margin-bottom: 40px
  &__subtitle
    font-size: 40px;
    line-height: 47px;
    color: #FFFFFF;
    margin-bottom: 97px
    text-align: center
    @media screen and (max-width: 812px)
      margin-bottom: 50px
  &__content
    display: flex
    justify-content: space-between
    @media screen and (max-width: 812px)
      flex-direction: column
      align-items: center
      justify-content: flex-start
  &__item
    display: flex
    flex-direction: column
    @media screen and (max-width: 812px)
      &:not(:last-child)
        margin-bottom: 40px
  &__img
    &-block
      margin: 0 auto
      margin-bottom: 43px
      height: 54px
      @media screen and (max-width: 812px)
        margin-bottom: 10px
        height: auto
  &__text
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: #FFFFFF;
    max-width: 178px
    @media screen and (max-width: 812px)
      font-size: 15px;
      line-height: 22px;
</style>
